import React from 'react';
import { Link } from 'react-router-dom';
import { Gamepad2, Mail, Instagram, Youtube, Shield, Award } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#0A0F1E] border-t border-[#1E2338] pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-12">
          {/* Brand */}
          <div className="space-y-4">
            <div className="flex items-center space-x-2">
              <Gamepad2 className="w-8 h-8 text-[#00fff5]" />
              <span className="text-2xl font-rajdhani font-bold text-white">
                The<span className="text-[#00fff5]">Arena</span>X
              </span>
            </div>
            <p className="text-gray-400 text-sm font-rajdhani">
              India's Premier Skill-Based Gaming Platform for BGMI and Free Fire Tournaments.
            </p>
            <div className="flex space-x-4">
              <a href="https://instagram.com/lastzoneindia" target="_blank" rel="noopener noreferrer" 
                 className="bg-[#1E2338] p-2 rounded-lg hover:bg-[#2A2F45] transition">
                <Instagram className="w-5 h-5 text-[#00fff5]" />
              </a>
              <a href="https://youtube.com/@lastzoneindia" target="_blank" rel="noopener noreferrer"
                 className="bg-[#1E2338] p-2 rounded-lg hover:bg-[#2A2F45] transition">
                <Youtube className="w-5 h-5 text-[#FF0000]" />
              </a>
              <a href="mailto:support@lastzoneindia.com"
                 className="bg-[#1E2338] p-2 rounded-lg hover:bg-[#2A2F45] transition">
                <Mail className="w-5 h-5 text-[#00fff5]" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-rajdhani font-bold text-lg mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li><Link to="/download" className="text-gray-400 hover:text-[#00fff5] transition font-rajdhani">Download App</Link></li>
              <li><Link to="/faq" className="text-gray-400 hover:text-[#00fff5] transition font-rajdhani">FAQ</Link></li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-white font-rajdhani font-bold text-lg mb-4">Legal</h3>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-gray-400 hover:text-[#00fff5] transition font-rajdhani">About Us</Link></li>
              <li><Link to="/terms" className="text-gray-400 hover:text-[#00fff5] transition font-rajdhani">Terms & Conditions</Link></li>
              <li><Link to="/privacy" className="text-gray-400 hover:text-[#00fff5] transition font-rajdhani">Privacy Policy</Link></li>
              <li><Link to="/refund" className="text-gray-400 hover:text-[#00fff5] transition font-rajdhani">Refund Policy</Link></li>
              <li><Link to="/fairplay" className="text-gray-400 hover:text-[#00fff5] transition font-rajdhani">Fair Play Policy</Link></li>
              <li><Link to="/guidelines" className="text-gray-400 hover:text-[#00fff5] transition font-rajdhani">Community Guidelines</Link></li>
            </ul>
          </div>

          {/* Trust Badges */}
          <div>
            <h3 className="text-white font-rajdhani font-bold text-lg mb-4">Trust & Safety</h3>
            <div className="space-y-3">
              <div className="flex items-center space-x-2 text-gray-400">
                <Shield className="w-5 h-5 text-[#00E676]" />
                <span className="font-rajdhani">Skill-Based Gaming</span>
              </div>
              <div className="flex items-center space-x-2 text-gray-400">
                <Award className="w-5 h-5 text-[#00E676]" />
                <span className="font-rajdhani">18+ Only</span>
              </div>
              <div className="flex items-center space-x-2 text-gray-400">
                <span className="w-5 h-5 text-[#EF4444] text-sm font-bold">⚠️</span>
                <span className="font-rajdhani">Not in Telangana, Odisha, Assam</span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-[#1E2338] pt-8 text-center">
          <p className="text-gray-500 font-rajdhani text-sm">
            © {new Date().getFullYear()} TheArenaX. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;